<script setup lang="ts">
import {PropType} from "vue";
import {useDialogPluginComponent} from "quasar";
import DialogCloseIcon from "@/assets/editViewIcons/DialogCloseIcon.vue";
import EditScreenList from "@/components/EditView/editScreens/EditScreenList.vue";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import Translator from "@/utils/common/Translator.ts";

const props = defineProps({
  guiActionResult: {type: Object as PropType<namaTypes.GUIActionResult>, required: true,},
  presenter: {type: Object as PropType<WidgetsPresenter>, required: true,}
});

const {dialogRef, onDialogCancel} = useDialogPluginComponent();
const listViewBlock = props.guiActionResult?.listView ?? {};

</script>

<template>
  <q-dialog ref="dialogRef" @hide="onDialogCancel" @keydown.esc="onDialogCancel" full-width full-height>
    <q-card class="tw-flex tw-flex-col tw-shadow-none dark:tw-bg-namaBackground-deep-dark tw-bg-namaBackground-deep-light !tw-rounded-none">
      <q-bar class="tw-flex-none tw-text-xs tw-text-namaFontColor-input-light tw-bg-[#CED4DA] dark:tw-bg-[#212529] dark:tw-text-white tw-h-10">
        <div class="tw-text-2xl tw-text-primary-light dark:tw-text-primary-dark tw-font-bold"
             v-text="Translator.translateTitledId(listViewBlock.listViewEntityType, listViewBlock)"/>
        <q-space/>
        <q-btn dense flat @click="onDialogCancel" title="Close"
               class="nama-btn-hover nama-custom-btn focus:tw-bg-transparent">
          <q-avatar square class="tw-w-5">
            <DialogCloseIcon/>
          </q-avatar>
        </q-btn>
      </q-bar>
      <q-card-section
        class="tw-grow tw-text-primary-light dark:tw-text-primary-dark tw-text-base tw-font-normal tw-flex-nowrap tw-overflow-y-auto">
        <EditScreenList :collapsed="false" :presenter="props.presenter" :block="listViewBlock" :blockIndex="0" :pageIndex="0"/>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped>

</style>
